module.exports = __webpack_public_path__ + "img/AME.473bd1b5.png";